import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ClassView from '../views/ClassView.vue'
import CenterView from '../views/CenterView.vue'
import ExerciseView from '../views/ExerciseView.vue'
import HomeworkView from '@/views/HomeworkView.vue'
import FRQView from '@/views/FRQView.vue'
import RealFRQView from '@/views/RealFRQView.vue'
import RealMCQView from '@/views/RealMCQView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/classes',
    name: 'class',
    component: ClassView
  },
  {
    path: '/center',
    name: 'center',
    component: CenterView
  },
  {
    path: '/exercises',
    name: 'exercise',
    component: ExerciseView
  },
  {
    path: '/homework',
    name: 'homework',
    component: HomeworkView
  },
  {
    path: '/frq',
    name: 'frq',
    component: FRQView
  },
  {
    path: '/real-frq',
    name:'real-frq',
    component: RealFRQView
  },
  {
    path: '/real-mcq',
    name:'real-frq',
    component: RealMCQView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
